// // src/layout/DashboardLayout.tsx
// import { ReactNode, useEffect, useState } from "react";
// import Sidebar from "./Sidebar";
// import Header from "./Header";
// import { motion } from "framer-motion";

// export default function DashboardLayout({
//   children,
// }: {
//   children: ReactNode;
// }) {
//   const [open, setOpen] = useState(false);

//   // 🔒 prevent background scroll when sidebar is open (mobile UX)
//   useEffect(() => {
//     if (open) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }
//   }, [open]);

//   return (
//     <div className="min-h-screen bg-[#131313] text-white">
//       {/* HEADER */}
//       <Header setOpen={setOpen} />

//       <div className="flex">
//         {/* SIDEBAR */}
//         <Sidebar open={open} setOpen={setOpen} />

//         {/* OVERLAY (mobile only) */}
//         {open && (
//           <div
//             onClick={() => setOpen(false)}
//             className="fixed inset-0 bg-black/60 z-40 md:hidden"
//           />
//         )}

//         {/* MAIN CONTENT */}
//         <motion.main
//           initial={{ opacity: 0, x: 20 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.4 }}
//           className="
//             flex-1
//             pt-20
//             px-4
//             sm:px-6
//             lg:px-12
//             md:ml-64
//             w-full
//           "
//         >
//           {children}
//         </motion.main>
//       </div>
//     </div>
//   );
// }


import { ReactNode, useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { motion } from "framer-motion";

export default function DashboardLayout({
  children,
}: {
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);

  // Prevent background scrolling when mobile sidebar is open.
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;

    document.body.style.overflow = open ? "hidden" : previousOverflow;

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  return (
    <div className="min-h-screen bg-[#131313] text-white">
      <Header setOpen={setOpen} />

      <div className="flex">
        <Sidebar open={open} setOpen={setOpen} />

        <motion.main
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4 }}
          className="
            min-w-0
            w-full
            flex-1
            pt-20
            px-4
            sm:px-6
            lg:px-12
            md:ml-64
          "
        >
          {children}
        </motion.main>
      </div>
    </div>
  );
}
